import React from "react";
import { Link } from "react-router-dom";
import { XCircle, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-6 py-20">
      <div className="bg-white rounded-3xl p-10 border border-slate-200 shadow-xl max-w-md w-full text-center" data-testid="payment-cancel">
        <XCircle className="h-16 w-16 text-brandred mx-auto mb-5" />
        <h2 className="font-head font-extrabold text-2xl text-navy">Payment Cancelled</h2>
        <p className="text-slate-600 mt-2">Your payment was cancelled. No amount has been charged. You can try again anytime.</p>
        <div className="flex gap-3 justify-center mt-7">
          <Link to="/parent-corner"><Button className="bg-brandred hover:bg-brandred/90 text-white rounded-full px-6">Try Again</Button></Link>
          <Link to="/"><Button variant="outline" className="rounded-full px-6"><Home className="mr-1.5 h-4 w-4" /> Home</Button></Link>
        </div>
      </div>
    </div>
  );
}
